export default {
    namespaced: true,
    state: {
        activeMenu: false
    },
    getters: {
        getActiveMenu (state) {
            return state.activeMenu;
        }
    },
    mutations: {
        setActiveMenu (state, payload) {
            state.activeMenu = payload;
        }
    },
    actions: {}
};
